// extracted by mini-css-extract-plugin
export default {"saveButton":"Dsu_N4GQ1RUVdurpgFqn","longButton":"s8uWtpNp07moqbIP1teA","popup":"EMyIwdoVerO9k7JaELOG"};